import { useEffect } from 'react';

import { type GAEvent, gaPush } from '#configuration/setup/googleAnalytics.ts';

export const useTrackScreenSeen = (onScreen: boolean, gaEvent: GAEvent) => {
    useEffect(() => {
        if (!onScreen) {
            return;
        }

        gaPush(gaEvent);
    }, [onScreen]);
};
